export * from './strings'

export const EMIAL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const MOBILE_NUMBER_REQUIRED = false;